var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServicePayment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M5.4,7.111H3.6a1.778,1.778,0,1,1,0-3.556H8.1a.889.889,0,1,0,0-1.778H5.4V.889a.9.9,0,0,0-1.8,0v.889a3.556,3.556,0,1,0,0,7.111H5.4a1.778,1.778,0,1,1,0,3.556H.9a.889.889,0,1,0,0,1.778H3.6v.889a.9.9,0,0,0,1.8,0v-.889a3.556,3.556,0,1,0,0-7.111",
    fill: "#909aac"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicePayment);
export default __webpack_public_path__ + "static/media/service_payment.c44a0e0d9c6814d8c618685e51a62a61.svg";
export { ForwardRef as ReactComponent };